var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.17289 9.375H6.7086V10.625H8.17289V9.375ZM11.1015 9.375H9.63717V10.625H11.1015V9.375ZM14.03 9.375H12.5657V10.625H14.03V9.375ZM15.4943 5H14.7622V3.75H13.2979V5H7.44074V3.75H5.97646V5H5.24432C4.43164 5 3.78735 5.5625 3.78735 6.25L3.78003 15C3.78003 15.6875 4.43164 16.25 5.24432 16.25H15.4943C16.2997 16.25 16.9586 15.6875 16.9586 15V6.25C16.9586 5.5625 16.2997 5 15.4943 5ZM15.4943 15H5.24432V8.125H15.4943V15Z",
    fill: "#727C8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5512b4b1fbcf7a4524d53882eaa823bd.svg";
export { ForwardRef as ReactComponent };